import React from "react"
import { Link } from "react-router-dom"
import { Badge, Table } from "reactstrap"
import { formatDate } from "helpers/misc_helpers"

const statusColors = {
  open: "success",
  evaluating: "warning",
  in_progress: "primary",
  completed: "secondary",
  cancelled: "danger",
}

const statusLabels = {
  open: "Open",
  evaluating: "Evaluating",
  in_progress: "In Progress",
  completed: "Completed",
  cancelled: "Cancelled",
}

const TraderRequestsList = ({ requests, isTrader }) => {
  if (!requests || requests.length === 0) {
    return (
      <p className="text-muted text-center mt-4">
        {isTrader ? "No requests available." : "No requests yet."}
      </p>
    )
  }

  return (
    <div className="table-responsive">
      <Table className="table align-middle table-nowrap table-hover">
        <thead className="table-light">
          <tr>
            <th>Title</th>
            <th>Status</th>
            <th>Parts</th>
            {!isTrader && <th>Offers</th>}
            <th>Created</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {requests.map(req => (
            <tr key={req.id}>
              <td>
                <strong>{req.title}</strong>
              </td>
              <td>
                <Badge color={statusColors[req.status] || "secondary"}>
                  {statusLabels[req.status] || req.status}
                </Badge>
                {isTrader && req.myOfferStatus === "selected" && (
                  <Badge color="success" className="ms-1">
                    My Offer Selected
                  </Badge>
                )}
              </td>
              <td>{req.partCount ?? "—"}</td>
              {!isTrader && <td>{req.offerCount ?? 0}</td>}
              <td>{formatDate(req.dateCreated)}</td>
              <td>
                <Link
                  to={`/trader-requests/${req.id}`}
                  className="btn btn-sm btn-outline-primary"
                >
                  View
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  )
}

export default TraderRequestsList
